import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AmplitudeService, AuthenticationService } from '@core/services';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent implements OnInit {
  constructor(
    private readonly _amplitudeService: AmplitudeService,
    private readonly _authenticationService: AuthenticationService
  ) {
    this._amplitudeService.initAmplitude();
  }

  ngOnInit() {
    const urlParams = new URLSearchParams(window.location.search);
    const accessToken = urlParams.get('access_token');
    const hasOAuthParams = Boolean(
      accessToken ||
      urlParams.get('refresh_token') ||
      urlParams.get('token_type') ||
      urlParams.get('expires_in') ||
      urlParams.get('expires_at') ||
      urlParams.get('user')
    );

    if (hasOAuthParams) {
      const userInfo: any = {
        access_token: accessToken,
      };

      const refreshToken = urlParams.get('refresh_token');
      const tokenType = urlParams.get('token_type');
      const expiresIn = urlParams.get('expires_in');
      const expiresAt = urlParams.get('expires_at');
      const userJson = urlParams.get('user');

      if (refreshToken) userInfo.refresh_token = refreshToken;
      if (tokenType) userInfo.token_type = tokenType;
      if (expiresIn) userInfo.expires_in = Number(expiresIn);
      if (expiresAt) userInfo.expires_at = Number(expiresAt);
      if (userJson) {
        try {
          userInfo.user = JSON.parse(decodeURIComponent(userJson));
        } catch (parseError) {
          console.warn('Failed to parse user payload from URL:', parseError);
        }
      }

      this._authenticationService.setUserDetail(userInfo);
      // remove token from URL
      window.history.replaceState({}, document.title, window.location.pathname);
      
      // Add a small delay to ensure token is properly stored
      setTimeout(() => {
        // Fetch complete user profile for OAuth logins
        this._authenticationService.fetchUserProfile().subscribe({
          next: (userProfile) => {
            if (userProfile) {
              console.log('Profile fetched');
            } else {
              console.log('No user profile returned');
            }
          },
          error: (error) => {
            console.error('Error fetching user profile:', error);
          }
        });
      }, 100);
    }
  }
}
